import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import tr from "@/i18n/tr";
import api from "@/lib/api";

const MONTHS_TR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const DAYS_TR = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
const firstWeekdayIndex = (y, m) => (new Date(y, m, 1).getDay() + 6) % 7;

export default function MiniCalendar() {
    const today = new Date();
    const [year, setYear] = useState(today.getFullYear());
    const [month, setMonth] = useState(today.getMonth());
    const [events, setEvents] = useState({});
    useEffect(() => {
        (async () => {
            try {
                const start = new Date(year, month, 1).toISOString();
                const end = new Date(year, month + 1, 0, 23, 59, 59).toISOString();
                const { data } = await api.get("/content-calendar", { params: { start, end, page_size: 200 } });
                const map = {};
                for (const e of data.items || []) {
                    const d = new Date(e.scheduled_at).getDate();
                    map[d] = { time: new Date(e.scheduled_at).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }), label: e.title, desc: e.customer_name || "—" };
                }
                setEvents(map);
            } catch { setEvents({}); }
        })();
    }, [year, month]);
    const total = daysInMonth(year, month);
    const first = firstWeekdayIndex(year, month);
    const cells = [];
    for (let i = 0; i < first; i++) cells.push(null);
    for (let d = 1; d <= total; d++) cells.push(d);
    const nav = (delta) => {
        const n = month + delta;
        if (n < 0) { setMonth(11); setYear(year - 1); }
        else if (n > 11) { setMonth(0); setYear(year + 1); }
        else setMonth(n);
    };
    const isToday = (d) => d === today.getDate() && month === today.getMonth() && year === today.getFullYear();
    return (
        <div className="card-elevated p-5">
            <div className="flex items-center justify-between mb-3">
                <div>
                    <div className="text-[13px] font-semibold text-foreground">{tr.dashboard.stats.calendar}</div>
                    <div className="text-[11.5px] text-muted-foreground mt-0.5">{MONTHS_TR[month]} {year}</div>
                </div>
                <div className="flex items-center gap-1">
                    <button onClick={() => nav(-1)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"><ChevronLeft className="h-4 w-4" /></button>
                    <button onClick={() => nav(1)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"><ChevronRight className="h-4 w-4" /></button>
                </div>
            </div>
            <div className="grid grid-cols-7 gap-1 mb-1">
                {DAYS_TR.map((d) => <div key={d} className="text-center text-[10px] font-bold uppercase text-muted-foreground">{d}</div>)}
            </div>
            <div className="grid grid-cols-7 gap-1">
                {cells.map((d, i) => d === null ? <div key={i} /> : (
                    <div key={i} className={`aspect-square rounded-lg text-[11px] font-semibold flex items-center justify-center relative ${isToday(d) ? "bg-[hsl(var(--brand))] text-white" : events[d] ? "bg-[hsl(var(--brand))]/10 text-[hsl(var(--brand))]" : "text-muted-foreground hover:bg-muted"}`} title={events[d] ? `${events[d].time} • ${events[d].label}` : ""}>
                        {d}
                        {events[d] && !isToday(d) && <span className="absolute bottom-1 h-1 w-1 rounded-full bg-[hsl(var(--brand))]" />}
                    </div>
                ))}
            </div>
        </div>
    );
}
